export const inquiryStatus = {
    WAITING: 'בהמתנה לנציג',
    FOLLOWUP: 'במעקב',
    APPROVAL: 'בהמתנה לאישור',
    PROGRESS: 'בטיפול',
    DONE: 'הטיפול הסתיים'
}

export const inquiryTypes = {
    DR_APPOINTMENT: 'תיאום תור לרופא',
    MEDICAL_TESTS: 'בדיקות רפואיות',
    RECOMMEND_DR: 'המלצה על רופא',
    OPINION: 'חוות דעת שניה',
    MONEY_REFUND: 'החזרת כספים',
    MY_RIGHTS: 'מה מגיע לי',
    DOUBLES: 'כפל חסר'
}

export const actionTitles = {
    covers: 'כיסויים',
    free_text: 'מלל חופשי',
    terms: 'תנאים למימוש',
    automatic: 'מענה אוטומטי',
    supplier_mail: 'שליחת מייל לספק'
}

export const popupTypes = {
    APPROVAL: {
        title: 'אישור פניה',
        desc: 'אנה אשר את פעולת הנציג',
        approveBtn: 'בצע',
        cancelBtn: 'ביטול'
    },
    MANUAL: {
        title: 'מענה ידני',
        desc: 'מלא את השדות הבאים למענה ידני',
        approveBtn: 'שלח תשובה',
        cancelBtn: 'ביטול'
    },
    AUTOMATIC: {
        title: 'מענה אוטומטי',
        desc: 'שלח מענה אוטומטי',
        approveBtn: 'שלח תשובה',
        cancelBtn: 'ביטול'
    },
    EMAIL: {
        title: 'שליחת מייל לספק',
        desc: 'בחר ספק לשליחת פרטי הלקוח',
        approveBtn: 'שלח תשובה',
        cancelBtn: 'ביטול'
    },
    RESTORE: {
        title: 'חדש טיפול בפניה',
        approveBtn: 'חדש טיפול',
        cancelBtn: 'ביטול'
    },
    END: {
        title: 'סיים טיפול',
        approveBtn: 'סיום טיפול',
        cancelBtn: 'ביטול'
    }
}
